module.exports = __webpack_public_path__ + "img/mega_pack_1.6c9607e5.png";